import React from "react";

const LiveLinkRequestUserItem = ({ user, removeRequest, setParticipant }) => {
  return (
    <div>
      {user.role === "innovator" && (
        <div className="single-user">
          <div className="outside-container">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                    className="drop-down-result-avi"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font">{user.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="user-buttons">
            <button className="user-button background-green">
              <i className="fas fa-check mx-5"></i>Accept
            </button>
            <button
              onClick={() => {
                setParticipant({
                  channelid: user.channelid,
                  avatar: user.avatar,
                  firstname: user.firstname,
                  lastname: user.lastname,
                });
                removeRequest(user.channelid);
              }}
              className="user-button background-red"
            >
              <i className="fas fa-times mx-5"></i>Decline
            </button>
          </div>
        </div>
      )}
      {user.role === "mentor" && (
        <div className="single-user">
          <div className="outside-container">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border red">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                    className="drop-down-result-avi"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font">{user.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="user-buttons">
            <button className="user-button background-green">
              <i className="fas fa-check mx-5"></i>Accept
            </button>
            <button
              onClick={() => {
                setParticipant({
                  channelid: user.channelid,
                  avatar: user.avatar,
                  firstname: user.firstname,
                  lastname: user.lastname,
                });
                removeRequest(user.channelid);
              }}
              className="user-button background-red"
            >
              <i className="fas fa-times mx-5"></i>Decline
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LiveLinkRequestUserItem;
